"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("../themes/theme.css"));
var ThemeContext = /*#__PURE__*/_react["default"].createContext(_theme["default"]);
var _default = exports["default"] = ThemeContext;